import { Directive, ElementRef, Input, OnChanges, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[boiCategorizeAccountCustomerStatus]'
})
export class CategorizeAccountCustomerStatusDirective implements OnInit, OnChanges {
  @Input() status: string;

  private readonly accountStatusStyle = {
    Active: 'active',
    Offline: 'offline',
    Pending: 'pending',
    Incomplete: 'incomplete'
  };

  constructor(private hostElement: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.addCaseStatusCssClass();
  }

  ngOnChanges(): void {
    this.addCaseStatusCssClass();
  }

  private addCaseStatusCssClass(): void {
    const cssClass = this.accountStatusStyle[this.status];

    if (this.hostElement.nativeElement.className) {
      this.renderer.removeClass(this.hostElement.nativeElement, this.hostElement.nativeElement.className);
    }
    this.renderer.addClass(this.hostElement.nativeElement, cssClass);
  }
}
